import { apiInstance } from '@core/api/instance';
import { getAPIURL } from '@common/api/helpers';
import { DictionariesEndpoint, Dictionary } from '@common/types';
import { IPlannerParams } from '@modules/planning/children/by-date/types';

export const PlanningParamsApi: IPlannerParams = {
  index: () => apiInstance().post(getAPIURL(Dictionary.PlannerParams, DictionariesEndpoint.Index))
};
